export { default } from "@casino/external/icons/SecuritySecurityAttention";
